import {createReducer, on} from "@ngrx/store";
import {AlgorithmicDmvActions} from "./algorithmic-dmv.actions";
import {AlgorithmicDmvState, initialAlgorithmicDmvState} from "./algorithmic-dmv.state";

export const algorithmicDmvReducer = createReducer<AlgorithmicDmvState>(
    initialAlgorithmicDmvState,

    on(AlgorithmicDmvActions.loadJobs, (state, {fundId}) => ({
        ...state,
        jobsByFund: {
            ...state.jobsByFund,
            [fundId]: {
                data: state.jobsByFund[fundId]?.data ?? [],
                status: "LOADING",
                errorMessage: ""
            }
        }
    })),
    on(AlgorithmicDmvActions.loadJobsSuccess, (state, {fundId, jobs}) => ({
        ...state,
        jobsByFund: {
            ...state.jobsByFund,
            [fundId]: {data: jobs, status: "LOADED", errorMessage: ""}
        }
    })),
    on(AlgorithmicDmvActions.loadJobsError, (state, {fundId, errorMsg}) => ({
        ...state,
        jobsByFund: {
            ...state.jobsByFund,
            [fundId]: {
                data: state.jobsByFund[fundId]?.data ?? [],
                status: "ERROR",
                errorMessage: errorMsg
            }
        }
    })),

    on(AlgorithmicDmvActions.loadDetail, state => ({
        ...state,
        // Keep the previously-loaded detail visible while reloading (e.g. the background refresh
        // after accept/skip) so the list isn't unmounted and the page doesn't jump to the top.
        // The viewer only shows the full-page "Loading…" placeholder when there is no data yet.
        activeDetail: {data: state.activeDetail.data, status: "LOADING", errorMessage: ""}
    })),
    on(AlgorithmicDmvActions.loadDetailSuccess, (state, {detail}) => ({
        ...state,
        activeDetail: {data: detail, status: "LOADED", errorMessage: ""}
    })),
    on(AlgorithmicDmvActions.loadDetailError, (state, {errorMsg}) => ({
        ...state,
        activeDetail: {data: undefined, status: "ERROR", errorMessage: errorMsg}
    })),

    on(AlgorithmicDmvActions.acceptResult, (state, {resultId}) => ({
        ...state,
        pendingActionResultIds: [...state.pendingActionResultIds, resultId]
    })),
    on(AlgorithmicDmvActions.skipResult, (state, {resultId}) => ({
        ...state,
        pendingActionResultIds: [...state.pendingActionResultIds, resultId]
    })),
    on(
        AlgorithmicDmvActions.acceptResultSuccess,
        AlgorithmicDmvActions.skipResultSuccess,
        AlgorithmicDmvActions.acceptResultError,
        AlgorithmicDmvActions.skipResultError,
        (state, {resultId}) => ({
            ...state,
            pendingActionResultIds: state.pendingActionResultIds.filter(id => id !== resultId)
        })
    ),

    on(AlgorithmicDmvActions.acceptAllSuggestions, state => ({...state, bulkAccepting: true})),
    on(
        AlgorithmicDmvActions.acceptAllSuggestionsSuccess,
        AlgorithmicDmvActions.acceptAllSuggestionsError,
        state => ({...state, bulkAccepting: false})
    ),

    on(AlgorithmicDmvActions.startError, (state, {errorMsg}) => ({...state, error: errorMsg})),
    on(AlgorithmicDmvActions.clearError, state => ({...state, error: undefined}))
);
